import { render, staticRenderFns } from "./Retencao.vue?vue&type=template&id=9e2d5f04&"
import script from "./Retencao.vue?vue&type=script&lang=js&"
export * from "./Retencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports